export enum RolesResourceEnum {
    ROLE_ADMIN = "ROLE_ADMIN",
    ROLE_NOOVLE = "ROLE_NOOVLE",
    ROLE_STOREMANAGER_FRANCHISING = "ROLE_STOREMANAGER_FRANCHISING",
    ROLE_STOREMANAGER_GDS = 'ROLE_STOREMANAGER_GDS',
    ROLE_STOREMANAGER_MULTIBRAND = 'ROLE_STOREMANAGER_MULTIBRAND',
    ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND = 'ROLE_STOREMANAGER_FLAGSHIP_MONOBRAND',
    ROLE_STOREMANAGER_SUPERVISOR = 'ROLE_STOREMANAGER_SUPERVISOR',
    ROLE_STORES_UPLOAD_MANAGER = 'ROLE_STORES_UPLOAD_MANAGER',
}